/** Taux indicatif — clients à l'étranger (1 EUR ≈ 3,35 TND) */
export const TND_PER_EUR = 3.35;

export function tndToEur(tnd) {
  return tnd / TND_PER_EUR;
}

export function formatTnd(value, locale = 'fr-FR') {
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  }).format(value);
}

export function formatEur(value, locale = 'fr-FR') {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function formatTndWithEur(tnd, locale = 'fr-FR', tndLabel = 'TND') {
  const tndFmt = formatTnd(tnd, locale);
  const eurFmt = formatEur(tndToEur(tnd), locale);
  return `${tndFmt} ${tndLabel} (${eurFmt})`;
}

export function formatTndRangeWithEur(min, max, locale = 'fr-FR', tndLabel = 'TND') {
  const tndFmt = `${formatTnd(min, locale)} – ${formatTnd(max, locale)} ${tndLabel}`;
  const eurFmt = `${formatEur(tndToEur(min), locale)} – ${formatEur(tndToEur(max), locale)}`;
  return `${tndFmt} (${eurFmt})`;
}
